(() => {
  if (window.HollowV2Gift) return;
  const node = document.getElementById('ds-v2-gift-section-config') || document.getElementById('ds-v2-gift-config');
  if (!node) return;
  let config;
  try {
    config = JSON.parse(node.textContent);
  } catch (error) {
    console.error('[v2-gift] Invalid gift configuration', error);
    return;
  }
  const base = window.Shopify?.routes?.root || '/';
  const refreshConfig = () => {
    const current = document.getElementById('ds-v2-gift-section-config') || document.getElementById('ds-v2-gift-config');
    config = JSON.parse(current.textContent);
  };
  const originalFetch = window.fetch.bind(window);
  const managed = item => item.properties?._v2_free_gift === '1';
  const discountReady = () => {
    if (config.discountReady) return true;
    // Permit staging QA only after Intelligems assigns this exact saved gift tier.
    if (new URLSearchParams(location.search).get('utm_source') !== 'v2giftqa' ||
        Number(config.variantId) !== 45935468413097) return false;
    const tiers = window.igData?.campaigns?.getGWP?.();
    return Array.isArray(tiers) && tiers.some(tier =>
      tier.id === '6b1a80c1-1166-4d4b-8b16-801fbc7108d9' &&
      String(tier.giftWithPurchaseProductId) === String(config.productId));
  };
  let queue = Promise.resolve();
  const serialize = task => {
    const next = queue.then(task);
    queue = next.catch(error => console.error('[v2-gift] Cart operation failed', error));
    return next;
  };
  const request = async (path, body) => {
    const response = await originalFetch(base + path, body ? {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    } : { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('Cart request failed: ' + response.status);
    return response.json();
  };
  const qualifyingCount = (cart, eligibleIds, giftProductId) => cart.items
    .filter(item => !managed(item) && item.properties?._v2_gift_qualifier === '1' &&
      Number(item.product_id) !== Number(giftProductId) &&
      (!eligibleIds?.length || eligibleIds.map(String).includes(String(item.product_id))))
    .reduce((total, item) => total + item.quantity, 0);
  const reconcile = async (addGift = false) => {
    refreshConfig();
    let cart = await request('cart.js');
    const gifts = cart.items.filter(managed);
    const seed = gifts[0] || cart.items.find(item => item.properties?._v2_gift_variant);
    if (config.cartOnly && !seed) return cart;
    if (!gifts.length && !addGift) return cart;
    const eligibleIds = config.cartOnly ? JSON.parse(seed.properties._v2_gift_products || '[]') : config.eligibleProductIds;
    const giftProductId = config.cartOnly ? (seed.properties._v2_gift_product || seed.product_id) : config.productId;
    const giftVariantId = config.cartOnly ? (seed.properties._v2_gift_variant || seed.variant_id) : config.variantId;
    const count = qualifyingCount(cart, eligibleIds, giftProductId);
    const eligible = (config.cartOnly || (config.enabled && discountReady())) && count >= config.minimumQuantity;
    const updates = {};
    let kept = false;
    for (const gift of gifts) {
      const free = gift.final_price === 0;
      if (!eligible || !free || Number(gift.variant_id) !== Number(giftVariantId) || kept) {
        updates[gift.key] = 0;
      } else {
        kept = true;
        if (gift.quantity !== 1) updates[gift.key] = 1;
      }
    }
    if (Object.keys(updates).length) cart = await request('cart/update.js', { updates });
    if (addGift && eligible && giftVariantId && (config.cartOnly || config.available) && !cart.items.some(managed)) {
      await request('cart/add.js', { items: [{ id: Number(giftVariantId), quantity: 1, properties: {
        _igGWP: 'true', _v2_free_gift: '1', _v2_gift_products: JSON.stringify(eligibleIds || [])
      } }] });
      cart = await request('cart.js');
      const unpaid = cart.items.filter(item => managed(item) && item.final_price !== 0);
      if (unpaid.length) cart = await request('cart/update.js', { updates: Object.fromEntries(unpaid.map(item => [item.key, 0])) });
    }
    return cart;
  };
  window.fetch = (input, init = {}) => {
    const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.origin);
    const method = String(init.method || input?.method || 'GET').toUpperCase();
    const mutation = url.origin === location.origin && method === 'POST' && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname);
    if (!mutation) return originalFetch(input, init);
    return serialize(async () => {
      const response = await originalFetch(input, init);
      if (response.ok) {
        let restoreGift = /\/cart\/add(?:\.js)?$/.test(url.pathname);
        if (/\/cart\/change(?:\.js)?$/.test(url.pathname) && typeof init.body === 'string' && init.body.trim().startsWith('{')) {
          const change = JSON.parse(init.body);
          restoreGift = Number(change.quantity) > 0;
        }
        await reconcile(restoreGift);
      }
      return response;
    });
  };
  const add = (items, qualifies) => serialize(async () => {
    refreshConfig();
    if (qualifies && (config.cartOnly || !config.enabled || !discountReady() || !config.available || !config.variantId)) {
      throw new Error(config.unavailableMessage);
    }
    const drawer = document.querySelector('ds-cart-drawer');
    const button = document.querySelector('.js-haus-atc');
    const previousCursor = button?.style.cursor || '';
    if (button) button.style.cursor = 'pointer';
    drawer?.setLoading?.(true);
    drawer?.open?.();
    try {
      await reconcile();
      const mark = !config.cartOnly && config.enabled && discountReady() && config.available && config.variantId;
      const payload = items.map(item => mark && Number(item.id) !== Number(config.variantId) ? {
        ...item, properties: { ...item.properties, _v2_gift_qualifier: '1',
          _v2_gift_variant: String(config.variantId), _v2_gift_product: String(config.productId),
          _v2_gift_products: JSON.stringify(config.eligibleProductIds || []) }
      } : item);
      await request('cart/add.js', { items: payload });
      const cart = await reconcile(true);
      const expectsGift = qualifies || (mark && qualifyingCount(cart, config.eligibleProductIds, config.productId) >= config.minimumQuantity);
      if (expectsGift && !cart.items.some(managed)) {
        throw new Error('Your socks were added, but the gift discount could not be applied. The beanie was removed so you will not be charged for it.');
      }
      return cart;
    } finally {
      try {
        if (drawer?.refreshHeaderCartSafe) await drawer.refreshHeaderCartSafe();
      } finally {
        drawer?.setLoading?.(false);
        if (button) button.style.cursor = previousCursor;
      }
    }
  });
  window.HollowV2Gift = { add, reconcile: () => serialize(reconcile) };
  const check = () => window.HollowV2Gift.reconcile().catch(error => console.error('[v2-gift] Could not check cart gifts', error));
  window.addEventListener('pageshow', check);
  if (document.readyState === 'complete') check();
})();